module.exports = __webpack_public_path__ + "public/img/youshipic.1b350264.png";